module.exports = __webpack_public_path__ + "static/media/graphic (code).e385e060.svg";